import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { get, orderBy } from 'lodash';

import ReactFileReader from 'react-file-reader';

import 'react-toastify/dist/ReactToastify.css';
import { displayErrors } from '../../../util/diversos';

import { fillColumns } from '../../../components/table';
import { Input155px, InputCampoBusca100px } from '../../../styles/inputGroup';
import IconButton from '../../../components/IconButton';

import Card from '../../../components/card';
import Loading from '../../loading';
import axiosCoto from '../../../services/axiosCoto';

export default function ConsultaCotacaoVendedor() {
  const [isLoading, setIsLoading] = useState(false);
  const [dataTableList, setDataTableList] = useState([]);
  const [selectedItens, setSelectedItens] = useState(null);

  const [nameArquivoXls, setNameArquivoXls] = useState('');
  const [arquivoXls, setArquivoXls] = useState(null);

  const [showInformacaoDialog, setShowInformacaoDialog] = useState(false);

  const [findField, setFindField] = useState('');
  const [sortField, setSortField] = useState('descricao');
  const [sortOrder, setSortOrder] = useState(null);
  const [dataTableColumn] = useState([
    { field: 'razaoSocial', header: 'Empresa', sort: true, style: { width: '40%' } },
    { field: 'descricao', header: 'Descricão', sort: true },
    { field: 'dataAbertura', header: 'Abertura', sort: false },
    { field: 'dataFechamento', header: 'Previsão Fechamento', sort: false, style: { width: '10%' } },
    { field: 'observacao', header: 'Observação', sort: false },
    { field: 'status', header: 'Status Cotação', sort: true },
    { field: 'cotacaoVendedorPrazo.statusCotacao', header: 'Minha situação', sort: true },
  ]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const idVendedor = useSelector((state) => state.auth.user.id);
  const razaoSocial = useSelector((state) => state.auth.user.razaoSocial);

  async function getData(searchFilter) {
    try {
      setIsLoading(true);

      let params = `/cotacao/paraconsultavendedor/?idVendedor=${idVendedor}`;

      if (searchFilter && searchFilter.findField !== '') {
        params = `${params}&${sortField}=${searchFilter.findField}`;
      }

      const listaCotacoes = [];
      await axiosCoto.get(params).then((response) => {
        for (let x = 0; x < response.data.length; x++) {
          if (response.data[x].cotacaoVendedores.length > 0) {
            if (response.data[x].cotacaoVendedores.some(cotacaoVendedores => cotacaoVendedores.idVendedor === idVendedor)) {
              listaCotacoes.push(response.data[x]);
            }
          } else {
            listaCotacoes.push(response.data[x]);
          }
        }
      });

      setDataTableList(listaCotacoes);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  const handleFind = () => {
    const searchFilter = {
      findField,
      idVendedor,
    };

    setFindField('');

    getData(searchFilter);
  };

  useEffect(() => {
    getData('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const informacaoDialogFooter = (
    <IconButton titulo=" Fechar " foco="false" mensagem="Sim" btnStyle="primary" onClick={() => setShowInformacaoDialog(false)} icon="check" />
  );

  // eslint-disable-next-line consistent-return
  const handleExportarExcel = async (e) => {
    e.preventDefault();

    const idComprador = get(selectedItens, 'idUsuario', 0);

    let isLiberado = false;
    await axiosCoto.get(`/usuariovendedorliberado?idComprador=${idComprador}&idVendedor=${idVendedor}`).then(async (res) => {
      if (res.data.length > 0) {
        isLiberado = true;
      } else {
        await axiosCoto.get(`/usuario/verificarvalidade/${idVendedor}`).then(dataValida => {
          if (!dataValida.data) {
            isLiberado = false;
            toast.info('Licença expirada');
            navigate('/financeirovendedor');
          } else {
            isLiberado = true;
          }
        });
      }
    });

    if (!isLiberado) {
      return false;
    }

    const id = get(selectedItens, 'id', 0);
    const status = get(selectedItens, 'status', 0);

    if (id > 0) {
      if (status === 'ABERTA') {
        // desativa os botoes de download e upload

        const params = `/cotacao/gerarexcel/${id}/${idVendedor}`;

        const headers = { 'Content-Type': 'blob' };
        const AxiosRequestConfig = { method: 'GET', url: params, responseType: 'arraybuffer', headers };

        try {
          await axiosCoto(AxiosRequestConfig).then(response => {
            const outputFilename = `cotacao_${new Date().toISOString('dd-mm-yyyy').substring(0, 10)}.xls`;

            // If you want to download file automatically using link attribute.
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', outputFilename);
            document.body.appendChild(link);
            link.click();

            // OR you can save/write file locally.
            // eslint-disable-next-line no-undef
            fs.writeFileSync(outputFilename, response.data);
            toast.info('Exportação realizada com sucesso');
          });
        } catch (error) {
          // console.log('error: ', error);
          // toast.warning('Não foi possível realizar a exportação');
        }
      } else {
        toast.warning('Esta cotação esta sendo respondida pelo comprador... aguarde.');
      }
    } else {
      toast.warning('Selecione uma cotação para exportar.');
    }
  };

  // eslint-disable-next-line consistent-return
  const handleImportarExcel = async (e) => {
    e.preventDefault();

    const idComprador = get(selectedItens, 'idUsuario', 0);

    let isLiberado = false;
    await axiosCoto.get(`/usuariovendedorliberado?idComprador=${idComprador}&idVendedor=${idVendedor}`).then(async (res) => {
      if (res.data.length > 0) {
        // deixar responder
        isLiberado = true;
      } else {
        await axiosCoto.get(`/usuario/verificarvalidade/${idVendedor}`).then(dataValida => {
          if (!dataValida.data) {
            isLiberado = false;
            toast.info('Licença expirada');
            navigate('/financeirovendedor');
          } else {
            isLiberado = true;
          }
        });
      }
    });

    if (!isLiberado) {
      return false;
    }

    const id = get(selectedItens, 'id', 0);
    const status = get(selectedItens, 'status', 0);

    if (id > 0) {
      if (status === 'ABERTA') {
        try {
          setIsLoading(true);

          if (arquivoXls != null && arquivoXls.base64.split(',')[1] !== null) {
            const shippingData = {
              id,
              idVendedor,
              razaoSocial,
              xls: arquivoXls.base64.split(',')[1],
            };

            // console.log('shippindata: ', shippingData);

            await axiosCoto.post('/cotacao/lerexcelcotacaovendedor/', shippingData).then(() => {
              toast.info('Importação realizada com sucesso');
            }).catch(error => {
              toast.warn(error.response.data);
            });
          } else {
            toast.info('Arquivo não selecionado.');
          }
        } catch (error) {
          toast.warn(`Arquivo não contêm xls válido. ${error}`);
        } finally {
          setIsLoading(false);
        }
      } else {
        toast.warning('Esta cotação esta sendo respondida pelo comprador... aguarde.');
      }
    } else {
      toast.warning('Selecione uma cotação para importar.');
    }
  };

  const handlePrecificar = (e) => {
    e.preventDefault();

    const id = get(selectedItens, 'id', 0);
    const status = get(selectedItens, 'status', 0);

    if (id > 0) {
      if (status === 'ABERTA') {
        navigate(`/cadastrocotacaovendedor/${id}`);
      } else {
        toast.warning('Esta cotação esta sendo respondida pelo comprador... aguarde.');
      }
    } else {
      toast.warning('Selecione uma cotação para responder.');
    }
  };

  const handleInformacoes = () => {
    setShowInformacaoDialog(true);
  };

  const onSort = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);

    setDataTableList(orderBy(dataTableList, [sortField], [sortOrder]));
  };

  const renderTablePrimeReact = useMemo(() => (
    <div>
      <div className="card">
        <DataTable
          value={dataTableList}
          size="small"
          stripedRows
          sortField={sortField}
          setOrder={sortOrder}
          onSort={onSort}
          responsiveLayout="scroll"
          selectionMode="single"
          selection={selectedItens}
          onSelectionChange={e => setSelectedItens(e.value)}
          selectableRows
          dataKey="id"
          paginator
          rows={10}
          emptyMessage="Nenhum registro a ser exibido"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{currentPage} de {totalPages}"
          rowsPerPageOptions={[10, 25, 50]}
        >
          {fillColumns(dataTableColumn)}
        </DataTable>
      </div>
    </div>
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [dataTableList, selectedItens]);

  const handleFiles = async (files) => {
    try {
      setIsLoading(true);

      if (files != null) {
        if (!files.base64.split(',')[0].includes('excel')) {
          toast.warn('O arquivo coletado não é um excel');
          return;
        }

        setArquivoXls(files);
        setNameArquivoXls(files.fileList[0].name);
      }
    } catch (e) {
      toast.warn('Arquivo não contêm xls válido.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Loading isLoading={isLoading} />
      <Card title="Cotações">
        <div>
          <div className="row align-items-center">
            <div className="col-8">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Buscar por:
                </Input155px>
                <InputCampoBusca100px className="p-inputgroup-addon">
                  {dataTableColumn.find(element => element.field === sortField).header}
                </InputCampoBusca100px>
                <InputText
                  autoFocus
                  maxLength={250}
                  value={findField}
                  onChange={e => setFindField(e.target.value)}
                />
                &nbsp; &nbsp;
                <IconButton titulo="" mensagem="Buscar" btnStyle="success" onClick={handleFind} icon="search" />
              </div>
            </div>
            <div className="col-4" style={{ textAlign: 'right' }}>
              <div className="p-inputgroup">
                <IconButton mensagem="Exportar Cotação para excel" btnStyle="primary" onClick={handleExportarExcel} icon="download" />
                <ReactFileReader fileTypes=".xls" base64 handleFiles={handleFiles}>
                  <div className="p-inputgroup">
                    <InputText
                      // eslint-disable-next-line jsx-quotes
                      placeholder='Selecione o arquivo'
                      disabled
                      value={nameArquivoXls}
                      onChange={e => setNameArquivoXls(e.target.value)}
                    />
                    <IconButton mensagem="Selecionar arquivo" btnStyle="secondary" onClick={() => {}} icon="file" />
                  </div>
                </ReactFileReader>
                <IconButton mensagem="Importar Cotação em excel" btnStyle="secondary" onClick={handleImportarExcel} icon="upload" />
                <IconButton mensagem="Precificar Produtos da Cotação" btnStyle="warning" onClick={handlePrecificar} icon="pencil" />
                <IconButton mensagem="Informações" btnStyle="primary" onClick={handleInformacoes} icon="question" />
              </div>
            </div>
          </div>
        </div>
        <br />

        {renderTablePrimeReact}

        <Dialog
          header="Respondendo a cotação"
          visible={showInformacaoDialog}
          style={{ width: '50vw' }}
          footer={informacaoDialogFooter}
          onHide={() => setShowInformacaoDialog(false)}
        >
          <p>
            Forma padrão:
            Prencher o Valor da Caixa e Quantidade por caixa, Valor Unitário será preenchido automaticamente e resposta salva no ato.
          </p>
          <p>
            Forma 2:
            Preencher a Quantidade por Caixa e o Valor Unitário, o Valor da Caixa será preenchido automaticamente e resposta salva no ato.
          </p>
          <p>
            Forma 3:
            Preencher somente o Valor Unitário, o Valor da Caixa será igual Valor Unitário e Quantidade por Caixa será 1 e resposta salva no ato.
          </p>
          <p>
            Forma 4:
            Preencher pelo excel. Poderá ser usada qualquer uma das formas anteriores.
            Os valores serão calculados na coleta.
            Produtos sem preenchimento com valorcx, qtdecx e valor unitário zerados não serão coletados.
            Após a coleta editar a cotação e preencher tipo entrega, prazo e forma de pagamento.
          </p>
        </Dialog>
      </Card>
    </>
  );
}
